import { Factory } from './Factory'
export class FormButtonFactory extends Factory {
  constructor(qty = 1) {
    super()
    this.qty = qty
  }

  create() {
    return {
      id: this.id('form-button'),
      component: 'editor-form-button',
      content: {
        text: 'submit'
      }
    }
  }
}